import Vue from 'vue';
import Vuex from 'vuex';

import test from './store/test/module';
import authentication from './store/authentication/module';
import growStatus from './store/grow-status/module';
import dashboard from './store/dashboard/module';
import lifecycles from './store/lifecycles/module';
import growplans from './store/growplans/module';
import productionPlanning from './store/production-planning/module';
import taskflowMain from './store/taskflow-main/module';
import facilities from './store/facilities/module';
import users from './store/users/module';
import growplanTask from './store/growplantask/module';
import plantContainer from './store/plantcontainer/module';
import platformsModule from './store/platforms/module';
import zones from './store/zones/module';
import productionSchedule from './store/production-schedule/module';
import zoneDevices from './store/zoneDevices/module';
import alerts from './store/alerts/module';
import controllerCommands from './store/controllerCommands/module';
import overviewDashboard from './store/overview-dashboard/module';
import boardComponents from './store/boardComponents/module';
import controllers from './store/controllers/module';
import calendar from './store/calendar/module';
import user from './store/user/module';
import platformPositions from './store/platformPositions/module';
import consumables from './store/consumables/module';
import navigation from './store/navigation/module';
import helpTopics from './store/helpTopics/module';
import socketMessages from './store/socketMessages/module';
import universalDashboard from './store/universalDashboard/module';
import batchActions from './store/batchActions/module';
import ticketingSystem from './store/ticketingSystem/module';
import statusFilterOptions from './store/statusFilterOptions/module';
import sensorFilterOptions from './store/sensorFilterOptions/module';
import sensorReadings from './store/sensorReadings/module';
import frontendPreferences from './store/frontendPreferences/module';
import repairTickets from './store/repairTickets/module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    test,
    authentication,
    growStatus,
    dashboard,
    lifecycles,
    growplans,
    productionPlanning,
    taskflowMain,
    facilities,
    users,
    growplanTask,
    plantContainer,
    platformsModule,
    zones,
    productionSchedule,
    alerts,
    zoneDevices,
    controllerCommands,
    overviewDashboard,
    boardComponents,
    controllers,
    calendar,
    user,
    consumables,
    platformPositions,
    navigation,
    helpTopics,
    socketMessages,
    universalDashboard,
    batchActions,
    ticketingSystem,
    statusFilterOptions,
    sensorFilterOptions,
    sensorReadings,
    frontendPreferences,
    repairTickets,
  },
});
